import type { UserAssessment } from "@core/assessments/types";
import type { ResourceAssessmentResult } from "../types/assessment-result.type";

/** Review and unfinished attempts have no final outcome or final score yet. */
export function getResourceAssessmentResult(
  attempt?: Pick<UserAssessment, "status" | "scorePercentage">,
): ResourceAssessmentResult | null {
  if (attempt?.status !== "passed" && attempt?.status !== "failed") return null;

  return {
    status: attempt.status,
    scorePercentage: Number.isFinite(attempt.scorePercentage)
      ? attempt.scorePercentage
      : undefined,
  };
}
